<template>
  <div class="normal-list">
    <div class="item-header-info">
      <span class="id">{{ idType }}: {{ item.orderIdStr || item.id }}</span>
      <span class="time">{{ createTime }}</span>
    </div>
    <div class="item-container">
    <div class="item-pic" :style="{ backgroundImage: 'url(' + $setPicSize(item.img) + ')' }">
      <!-- <div v-if="item.status && item.status.length <= 4" class="status">
        <span>{{ itemState }}</span>
      </div> -->
    </div>
    <div class="item-info">
      <div class="title">
        <span v-if="item.orderType == 2" class="tag"></span>
        <span >{{ item.title }}</span>
      </div>
      <div class="time-and-price-desc">
        <div v-if="item.orderType != 2" class="price">
        <div v-if="item.price / 100 > 0">
          <em>￥</em><span>{{ item.price / 100 }}</span>
        </div>
        </div>
        <div v-if="item.orderType == 2" class="price">
        ⭐<span>{{ item.payStar }}</span>
        </div>
        <span class="itemState">{{ itemState }}</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
import '../../../../../lib/utils'
import phoneImg from '../../../../../assets/img/phone.png'
import bookImg from '../../../../../assets/img/books.png'

export default {
  name: 'NormalList',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    idType() {
      let res = ''
      if (this.item.type === 'goods') res = '商品'
      else if (this.item.type === 'order') res = '订单'
      return res
    },
    createTime() {
      return this.item.time ? new Date(Number(this.item.time)).format('YYYY-MM-DD') : '' //  2018-02-21
    },
    itemState() {
      // if (this.item.status.length > 4) {
      //   return this.item.status.slice(0, 4)
      // }
      return this.item.status
    }
  },
  methods: {
    $setPicSize(url) {
      if (this.item.orderType == 3) return phoneImg
      if (this.item.orderType == 4) return bookImg
      return setPicSize(url, 100, 100)
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
